
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/new-password",
      function () {
        return require("private-next-pages/auth/new-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/new-password"])
      });
    }
  